import SEO from "@/components/SEO";
import GhlFormEmbed from "@/components/GhlFormEmbed";

const Contact = () => {
  return (
    <>
      <SEO path="/contact" />

      <section className="bg-ivory" data-testid="contact-hero">
        <div className="max-w-[1320px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-8">
          <h1 className="sr-only">Contact Shiva Murti Sacred Healing Arts</h1>
          <p className="eyebrow">Contact</p>
        </div>
      </section>

      <section className="bg-ivory" data-testid="contact-form-section">
        <div className="max-w-3xl mx-auto px-6 md:px-12 pb-24 md:pb-32" data-testid="contact-embed-wrap">
          <GhlFormEmbed
            formId="ATk4g8a0ZK7rs08MQTKP"
            formName="General Request"
            title="Contact — Shiva Murti Sacred Healing Arts"
            height={1133}
            testId="contact-embed"
          />
        </div>
      </section>
    </>
  );
};

export default Contact;
